// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".automation-container[data-v-36b4a1be]{background-color:var(--v-background-base,#f5f5f5)}.theme--dark .automation-container[data-v-36b4a1be]{background-color:#121212!important}", ""]);
// Exports
module.exports = exports;
